// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nbody[data-v-2093a8f8] {\n    min-width:100% !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
